import { combineReducers } from "redux";
import onboardingReducer from "./onboarding";

export default combineReducers({
  onboarding: onboardingReducer,
});
